import { NgModule } from "@angular/core";
import { SharedModule } from '../../shared/module/shared.module';
import {NgSelectModule} from '@ng-select/ng-select';

@NgModule({
    imports: [
        SharedModule,
        NgSelectModule
        
    ],
    declarations: [],
    exports: [NgSelectModule]
  })
  export class AdvancedSearchModule { }


// WEBPACK FOOTER //
// ./src/app/shared/advanced-search/advanced-search.module.ts